import Helpers from '../helpers'

export default {
    mixins: [Helpers],

    methods: {
        trackViewItemPSF() {
            let price = _.get(apr, 'psf_search_results.best_rate') || _.get(this, 'hotel.overview.prices.avg') || null;
            let currency = _.get(apr, 'hotel.address.country.code') === 'CA' && _.get(apr, 'hotel.info.pricing') !== 'separated' ? 'CAD' : 'USD';
            let searchWasPerformed = _.get(apr, 'psf_search_results') !== null;
            let available = _.get(apr, 'psf_search_results.available', false)
            let itemVariant = searchWasPerformed ? (available ? 'available' : 'sold out') : null;

            dataLayer.push({
                'event': 'view_item',
                'ecommerce': {
                    'currency': price ? currency : null,
                    'value':  price,
                    'items': [
                        {
                            'item_id': `PSF ${_.get(this.hotel, 'hotel_id')}`,
                            'item_name': `PSF ${_.get(this.hotel, 'airport.code')} ${_.get(this.hotel, 'name')}`,
                            'coupon': null,
                            'discount': 0,
                            'index': 0,
                            'item_brand': null,
                            'item_category': this.getLotCategory('PSF'),
                            'item_category2': null,
                            'item_category3': null,
                            'item_category4': null,
                            'item_category5': null,
                            'item_variant': itemVariant,
                            'price': price,
                            'quantity': 1,
                        },
                    ],
                }
            });
        },

        trackViewItemAPR() {
            let soldOut = _.get(this, 'soldOut');
            let airportCountry = _.get(apr, 'content.airport.country');
            let airportCode = _.get(apr, 'content.airport.code');
            let price = soldOut ? null : _.get(this, 'parkinglot.rate');
            let currency = soldOut ? null : (airportCountry === 'CA' ? 'CAD' : 'USD');
            let providerName = this.content.parkinglot.provider;
            let searchWasPerformed = this.checkin_value !== '';
            let itemVariant = searchWasPerformed ? (soldOut ? 'sold out' : 'available') : null;

            dataLayer.push({
                'event': 'view_item',
                'ecommerce': {
                    'currency': price ? currency : null,
                    'value':  price,
                    'items': [
                        {
                            'item_id': this.parkinglot.id,
                            'item_name': `${airportCode} ${this.parkinglot.name}`,
                            'coupon': null,
                            'discount': 0,
                            'index': 0,
                            'item_brand': null,
                            'item_category': this.getLotCategory(providerName),
                            'item_category2': null,
                            'item_category3': null,
                            'item_category4': null,
                            'item_category5': null,
                            'item_variant': itemVariant,
                            'price': price,
                            'quantity': 1,
                        },
                    ],
                }
            });
        }
    }
}